import { render } from "./orderManage.vue?vue&type=template&id=975a64fc&scoped=true"
const script = {}

import "./orderManage.vue?vue&type=style&index=0&id=975a64fc&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975a64fc"]])

export default __exports__